
const shell = require('shelljs')
const { accent, STORAGE_DIR_PATH } = require('common')

module.exports = () => {
	console.log(accent("ops purge --\n"))
    shell.exec("rm -rf " + STORAGE_DIR_PATH)
    console.log(accent("\n\tcli storage purged.\n"))
}


// WEBPACK FOOTER //
// ./src/commands/purge.js